import { cn } from '@/lib/utils'

import { CARD_CONTAINER_CLASSES } from './styles'

import type { ProductCardSkeletonProps } from '../../types'

const SKELETON_IMAGE_CLASSES = 'w-full min-h-[280px] h-[320px] xl:h-[380px] bg-border-color/40 rounded mb-4'

const SKELETON_NAME_CLASSES = 'h-4 bg-border-color/40 rounded w-full'

const SKELETON_PRICE_CLASSES = 'h-6 bg-border-color/40 rounded w-24 mt-auto'

/**
 * ProductCardSkeleton - Loading placeholder for ProductCard
 *
 * @example
 * {isLoading ? <ProductCardSkeleton /> : <ProductCard product={product} renderActions={(p) => <ProductCardActions product={p} />} />}
 */
export function ProductCardSkeleton({ className }: ProductCardSkeletonProps) {
  return (
    <div
      className={cn(CARD_CONTAINER_CLASSES, 'animate-pulse', className)}
      aria-busy="true"
      aria-label="Loading product"
    >
      <div className={SKELETON_IMAGE_CLASSES} />

      <div className="flex flex-col gap-3 w-full">
        <div className={SKELETON_NAME_CLASSES} />
        <div className={cn(SKELETON_NAME_CLASSES, 'w-2/3')} />
        <div className={SKELETON_PRICE_CLASSES} />
      </div>
    </div>
  )
}
